// store.js
import { createStore, combineReducers } from 'redux';
import authReducer from './authReducer';
import adminReducer from './adminReducer';

const rootReducer = combineReducers({
    auth: authReducer,
    admin: adminReducer
});

const store = createStore(rootReducer);

export default store;